import type { ReactNode } from "react";
import "./admin-reload.css";

/**
 * "Načti data znovu" je v Servisu jedna akce, tak má jeden tvar, jedno slovo a
 * jedno místo. Dřív ji každý panel kreslil po svém: Provoz plné tlačítko vpravo
 * v hlavičce, Importy drobné o kus níž mezi počítadly, Stripe pod výpisem
 * událostí a ještě jiným slovem ("Obnovit"), Diagnostika textový odkaz úplně
 * dole. Oko se tak muselo tutéž věc naučit čtyřikrát a v jednom panelu ji
 * hledalo pod jiným jménem.
 *
 * `AdminReloadRow` je pro panely bez vlastní hlavičky: drží tlačítko vpravo
 * nahoře nad obsahem. Panel s hlavičkou (Provoz) vkládá samotné `AdminReload`
 * na své místo vpravo.
 */
export function AdminReload(props: {
  onClick: () => void;
  t: (key: string) => string;
  busy?: boolean;
}) {
  return (
    <button className="secondary-button compact-button" type="button"
      disabled={props.busy === true} onClick={props.onClick}>
      {props.t("staffConsole.adminReload")}
    </button>
  );
}

/**
 * S2-15: the row used to be 1282 px of nothing with a button at the far right,
 * so every panel opened on emptiness instead of on its content, and the panel
 * "Zaseklé přepisy" carried the same strip twice, 2468 px apart. It takes a
 * left side now: whatever the panel wants to say first (the count it stands
 * over, the state it is in), and the reload sits opposite it. One strip per
 * panel, at the top, like the panels that have their own header.
 */
export function AdminReloadRow(props: {
  onClick: () => void;
  t: (key: string) => string;
  busy?: boolean;
  children?: ReactNode;
}) {
  return (
    <div className="admin-reload-row">
      <div className="admin-reload-row-lead">{props.children}</div>
      <AdminReload busy={props.busy} onClick={props.onClick} t={props.t} />
    </div>
  );
}
